export function toIsoDate(value) {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toISOString().slice(0, 10);
}

export function currentMonthValue() {
  return new Date().toISOString().slice(0, 7);
}

export function monthRange(monthValue) {
  const [year, month] = String(monthValue || "").split("-").map(Number);
  if (!Number.isFinite(year) || !Number.isFinite(month)) {
    return { start_date: "", end_date: "", label: "" };
  }
  const start = new Date(year, month - 1, 1);
  const end = new Date(year, month, 0);
  const label = new Intl.DateTimeFormat("en-CA", {
    month: "long",
    year: "numeric",
  }).format(start);
  return {
    start_date: toIsoDate(start),
    end_date: toIsoDate(end),
    label,
  };
}

export function monthValueFromDate(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toISOString().slice(0, 7);
}

export function requestMatchesMonth(request, selectedMonth) {
  if (!selectedMonth) return true;
  const values = [
    request?.period_start,
    request?.period_end,
    request?.due_date,
    request?.created_at_utc,
  ].map(monthValueFromDate);
  return values.includes(selectedMonth);
}

export function money(value) {
  const number = Number(value || 0);
  return number.toLocaleString("en-CA", {
    style: "currency",
    currency: "CAD",
  });
}
